import { render } from "./MainFooter.vue?vue&type=template&id=aaac0a12&scoped=true&ts=true"
import script from "./MainFooter.vue?vue&type=script&lang=ts"
export * from "./MainFooter.vue?vue&type=script&lang=ts"

import "./MainFooter.vue?vue&type=style&index=0&id=aaac0a12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaac0a12"]])

export default __exports__